import { render, staticRenderFns } from "./ind_form.vue?vue&type=template&id=c2486318"
import script from "./ind_form.vue?vue&type=script&lang=js"
export * from "./ind_form.vue?vue&type=script&lang=js"
import style0 from "./ind_form.vue?vue&type=style&index=0&id=c2486318&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports